// extracted by mini-css-extract-plugin
export var dropdownIcon = "_ro-6";
export var imgContainer = "_ro-3";
export var menuIcon = "_ro-5";
export var pillWrapper = "_ro-2";
export var pillsContainer = "_ro-1";
export var subscriptionCard = "_ro-0";
export var subscriptionLogo = "_ro-4";